<nav class="c-sidebar" [class.c-sidebar--collapsed]="layout.sidebarCollapsed()" aria-label="Navigation principale">
  @for (group of groups(); track group.id) {
    <div class="c-sidebar__group">
      @if (group.labelKey && !layout.sidebarCollapsed()) {
        <p class="c-sidebar__group-title">{{ group.labelKey | translate }}</p>
      }
      <ul class="c-sidebar__list">
        @for (item of group.items; track item.id) {
          <li>
            <a class="c-sidebar__link" [routerLink]="item.route" routerLinkActive="is-active"
               [title]="item.labelKey | translate">
              <i class="c-sidebar__icon {{ item.icon }}" aria-hidden="true"></i>
              @if (!layout.sidebarCollapsed()) {
                <span class="c-sidebar__label">{{ item.labelKey | translate }}</span>
              }
            </a>
          </li>
        }
      </ul>
    </div>
  }

  <button class="c-sidebar__link c-sidebar__logout" type="button" (click)="logout()"
          [title]="'AUTH.LOGOUT' | translate">
    <i class="c-sidebar__icon fa-solid fa-right-from-bracket" aria-hidden="true"></i>
    @if (!layout.sidebarCollapsed()) {
      <span class="c-sidebar__label">{{ 'AUTH.LOGOUT' | translate }}</span>
    }
  </button>
</nav>
